import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faCloudBolt, faExclamationCircle, faBullseye, faUserTie, faProjectDiagram, faCircleArrowDown, faFish, faClipboard, faHeart, faHeartCircleCheck, faUserGroup, faDollarSign, faSchool } from '@fortawesome/free-solid-svg-icons';
import './FiveWhysHome.css';
import fivewhysimage from '../../assets/pageimages/FiveWhys.webp';

function FiveWhysKidsHome() {
  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-blue-300 via-blue-500 to-blue-700 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-2'>5Whys Analysis</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex justify-center mb-6">
            <img src={fivewhysimage} alt="5Whys Analysis" style={{width:'300px', height: 'auto'}}className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md" />
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            <CardLink to="/think5whys-db-list" icon={faDatabase} text="Examples" />
            <CardLink to="/think5whys-extension-example" icon={faCloudBolt} text="Kis Issues Extensive Use-Cases" />
            <CardLink to="/my-concerns-list" icon={faExclamationCircle} text="Kids Concerns" />
            <CardLink to="/my-objectives-list" icon={faBullseye} text="Kids Objectives" />
            <CardLink to="/think5whys-extension-my" icon={faCloudBolt} text="Kids Extensive Report" />
            <CardLink to="/statistics-analysis" icon={faCircleArrowDown} text="Statistics & Analytics" />
            <CardLink to="/fishbones" icon={faFish} text="Fishbones Diagram" />

              {/* <div className="flex">
                <Link to="/think5whys-db-list" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faDatabase} className="text-xl text-blue-600 mr-3" />
                  <span className="text-gray-800">Examples for Everyone</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/think5whys-extension-example" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faCloudBolt} className="text-xl text-yellow-600 mr-3" />
                  <span className="text-gray-800">Extensive Use-Cases</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/my-concerns-list" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faExclamationCircle} className="text-xl text-red-600 mr-3" />
                  <span className="text-gray-800">My Concerns</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/my-objectives-list" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faBullseye} className="text-xl text-green-600 mr-3" />
                  <span className="text-gray-800">My Objectives</span>
                </Link>
              </div> */}
              {/* <div className="flex">
                <Link to="/team-concerns-list" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faUserTie} className="text-xl text-purple-600 mr-3" />
                  <span className="text-gray-800">Team's Concerns</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/team-objectives-list" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faProjectDiagram} className="text-xl text-teal-600 mr-3" />
                  <span className="text-gray-800">Team's Objectives</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/think5whys-extension-my" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faCloudBolt} className="text-xl text-orange-600 mr-3" />
                  <span className="text-gray-800">My Extensive Report</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/statistics-analysis" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faCircleArrowDown} className="text-xl text-indigo-600 mr-3" />
                  <span className="text-gray-800">Statistics & Analytics</span>
                </Link>
              </div>
              <div className="flex">
                <Link to="/fishbones" className="flex-1 flex items-center justify-center p-4 bg-white rounded-lg shadow hover:bg-gray-100 transition duration-300">
                  <FontAwesomeIcon icon={faFish} className="text-xl text-teal-600 mr-3" />
                  <span className="text-gray-800">Fishbones Diagram</span>
                </Link>
              </div> */}
            </div>
          </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={""} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default FiveWhysKidsHome;
